// extracted by mini-css-extract-plugin
var _1 = "Breadcrumbs-module__animatedBackground--PhAA5";
var _2 = "Breadcrumbs-module__container--XzG0x";
var _3 = "Breadcrumbs-module__small--vFeal";
var _4 = "Breadcrumbs-module__truncate--ZBRti";
export { _1 as "animatedBackground", _2 as "container", _3 as "small", _4 as "truncate" }
